import React from "react"

import {FieldControlViewProps} from "../../../render/control-view"
import FieldDropdown from "../dropdown"
// import ControlButtonStandard from "../../../../gd-components/buttons/control-button/control-button-standard"
// import {ControlButtonSize} from "../../../../gd-components/buttons/control-button/@types"

type State = {
    initialPropsValue   : any
    currentOption       : any
    showPopover         : boolean
}

// const debug = "FieldDropdown_ControlView"
const debug = false

export default class FieldDropdown_ControlView extends React.Component<FieldControlViewProps, State> {

    private previousOption: any

    constructor(props: FieldControlViewProps) {
        super(props)

        const value = this.props.model[this.props.field.fieldId]

        this.state = {
            initialPropsValue   : value, // required to check if currentOption update needed on props changed
            currentOption       : props.field._getOption(value),
            showPopover         : false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        const value = props.model[props.field.fieldId]

        if (value !== state.initialPropsValue) {
            return {
                initialPropsValue   : value,
                currentOption       : props.field._getOption(value)
            }
        }

        return null // no changes
    }

    showPopover = (e?:React.SyntheticEvent) => {
        debug && console.log(debug, 'showPopover', e)

        e?.stopPropagation()

        this.setState({
            showPopover: true
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover: false
        })
    }

    onOptionClick = (option:any) => {
        this.previousOption = this.state.currentOption
        if (!option || _.isNil(option.value)) option = null

        this.setState({
            currentOption: option
        }, () => {
            if (option?.onClick) {
                option.onClick()
            } else {
                this.props.onChange?.(_.get(option, 'value', null), option)
            }
            this.hidePopover()
        })
    }

    onCancelChange = () => {
        this.setState({
            currentOption: this.previousOption
        });
    }

    render() {
        const field: FieldDropdown = this.props.field as FieldDropdown

        /*const option    = field._getOption(this.props.model[this.props.field.fieldId])
        const icon      = _.get(option, 'icon', field.placeholderIcon)
        const label     = _.get(option, 'label', field.placeholder)

        const classes = Classes("s-28 p-l-6 p-r-6", this.props.className, {
            'is-empty'      : !option,
            'show-popover'  : this.state.showPopover
        })

        const iconClasses = Classes("icon ui5-ico-13 m-r-5", icon)

        debug && console.log(debug, 'render', option, this.props)

        return (
            <ControlButtonStandard className        = {classes}
                                   size             = {ControlButtonSize.SIZE_28}
                                   selectedClass    = "hover-bg"
                                   isSelected       = {true}
                                   onClick          = {this.showPopover}>
                <div className={iconClasses}/>
                <div className="label txt-truncate ui5-txt-not-important-small">{label}</div>

                {this.state.showPopover && <field.components.PopoverMenu {...this.props}
                                                                         parent         = {this}
                                                                         currentOption  = {option}/>}
            </ControlButtonStandard>
        )*/

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        });

        const isNotEmpty = this.state.currentOption && (field.hasOptionWithNullValue || !_.isNil(this.state.currentOption.value))
        debug && console.log(debug, 'render', isNotEmpty, this.props)

        // need check value because of none
        if (isNotEmpty) {
            return (
                <field.components.ControlViewNotEmpty className = {classes}
                                                      field     = {this.props.field}
                                                      option    = {this.state.currentOption}
                                                      params    = {this.props.params}
                                                      onClick   = {this.showPopover}
                                                      onChange  = {this.onOptionClick}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </field.components.ControlViewNotEmpty>
            );
        } else {
            return (
                <field.components.ControlViewEmpty className    = {classes}
                                                   field        = {this.props.field}
                                                   params       = {this.props.params}
                                                   onClick      = {this.showPopover}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </field.components.ControlViewEmpty>
            );
        }
    }
}
